var Vue = require('vue');
var ScoreSetsList = require('./components/ScoreSetsList.vue').default;
var ListActionDropdown = require('../../lib/components/ListActions/ListActionDropdown.vue').default;
var Marker = require('../../lib/markers/marker.js');
var Deletism = require('../../lib/markers/deletism.js');
var Undeletism = require('../../lib/markers/undeletism.js');
var Copier = require('../../lib/markers/copier.js');
var Columnator = require('../../lib/columnator.js');
var IndexView = require('../../lib/index-view.js');

module.exports = function () {
  const scoreSetsList = new Vue({
    el: '#score-sets-list',
    components: {
      'list-action-dropdown': ListActionDropdown,
      'score-sets-list': ScoreSetsList
    }
  });

  $(document).one('pjax:end', () => {
    scoreSetsList.$destroy();
  });

  var marker = new Marker();

  new IndexView();

  new Deletism(marker);
  new Undeletism(marker);
  new Copier(marker);

  new Columnator();
};
